export default __webpack_public_path__ + "static/media/rodape_web.e0c72cde.svg";